import {useSagaCallback} from "../store/sagas";
import {useCallback} from "react";
import {call} from "redux-saga/effects";
import {apiPost} from "./client";

export const useRetryPreview = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id) {
        yield call(apiPost, `/api/v2/moderate/retry_preview`, {
            id,
        });
    }, []));
};
